import * as React from 'react';
import * as ReactDOM from 'react-dom/client';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import '../tailwind.css';
import './index.css';

const shouldRecoverFromAssetError = (message: string | undefined | null) => {
  if (!message) return false;
  return /ChunkLoadError|Loading chunk|Failed to fetch dynamically imported module|Importing a module script failed/i.test(message);
};

const recoverFromAssetError = async () => {
  try {
    if (sessionStorage.getItem('app_recovered') === '1') return;
    sessionStorage.setItem('app_recovered', '1');
  } catch {}

  try {
    localStorage.removeItem('user');
    localStorage.removeItem('isAuthenticated');
  } catch {}

  try {
    if ('caches' in window) {
      const keys = await caches.keys();
      await Promise.all(keys.map((k) => caches.delete(k)));
    }
  } catch {}

  window.location.replace(window.location.href);
};

window.addEventListener('error', (event) => {
  const e = event as ErrorEvent;
  if (shouldRecoverFromAssetError(e?.message)) {
    void recoverFromAssetError();
  }
});

window.addEventListener('unhandledrejection', (event) => {
  const e = event as PromiseRejectionEvent;
  const reason: any = e?.reason;
  const message = typeof reason === 'string' ? reason : reason?.message;
  if (shouldRecoverFromAssetError(message)) {
    void recoverFromAssetError();
  }
});

/**
 * SPA Refresh Handler
 * Check if we were redirected from a sub-path via 404.html
 */
const redirectPath = sessionStorage.getItem('redirectPath');
if (redirectPath) {
  sessionStorage.removeItem('redirectPath');
  window.history.replaceState(null, '', redirectPath);
}

/**
 * Application entry point
 * Initializes the React application and mounts it to the DOM
 * Includes both Tailwind CSS and custom CSS styles
 */

// Get the root DOM element where the React app will be mounted
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// Render the App component inside StrictMode for development checks
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister(); 
